import FoodEstablishment from '../../schema/innerSchema/FoodEstablishment';
import assignAddress from './assignAddress';

export default function setRestaurantData(diningEntity: any): FoodEstablishment {
    let restaurantAddress = assignAddress({}, diningEntity.reservationFor.address);
    return {
        name: diningEntity.reservationFor.name,
        address: restaurantAddress,
        telephone: diningEntity.reservationFor.telephone,
        city: diningEntity.reservationFor.city,
    } as FoodEstablishment;
}
